const prblSelect = [
    {
        labelcz: 'PRBL_SELECT_0',
        value: '0'
    },
    {
        labelcz: 'PRBL_SELECT_1',
        value: '1'
    }
];

export default prblSelect;
